module.exports = __webpack_public_path__ + "assets/img/img7.abf38bc7.png";